/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertAssignmentCommand } from './InternalApiAlertAssignmentCommand';
import {
    InternalApiAlertAssignmentCommandFromJSON,
    InternalApiAlertAssignmentCommandFromJSONTyped,
    InternalApiAlertAssignmentCommandToJSON,
    InternalApiAlertAssignmentCommandToJSONTyped,
} from './InternalApiAlertAssignmentCommand';

/**
 * Optional alert assignment (assignment not returned when there was nothing to assign)
 * @export
 * @interface InternalApiOptionalAlertAssignment
 */
export interface InternalApiOptionalAlertAssignment {
    /**
     * 
     * @type {InternalApiAlertAssignmentCommand}
     * @memberof InternalApiOptionalAlertAssignment
     */
    assignment?: InternalApiAlertAssignmentCommand;
}

/**
 * Check if a given object implements the InternalApiOptionalAlertAssignment interface.
 */
export function instanceOfInternalApiOptionalAlertAssignment(value: object): value is InternalApiOptionalAlertAssignment {
    return true;
}

export function InternalApiOptionalAlertAssignmentFromJSON(json: any): InternalApiOptionalAlertAssignment {
    return InternalApiOptionalAlertAssignmentFromJSONTyped(json, false);
}

export function InternalApiOptionalAlertAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiOptionalAlertAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'assignment': json['assignment'] == null ? undefined : InternalApiAlertAssignmentCommandFromJSON(json['assignment']),
    };
}

export function InternalApiOptionalAlertAssignmentToJSON(json: any): InternalApiOptionalAlertAssignment {
    return InternalApiOptionalAlertAssignmentToJSONTyped(json, false);
}

export function InternalApiOptionalAlertAssignmentToJSONTyped(value?: InternalApiOptionalAlertAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignment': InternalApiAlertAssignmentCommandToJSON(value['assignment']),
    };
}

